"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.editDistribution = exports.createNewDistribution = exports.changeStep = exports.getDelay = void 0;
const fp = require("fp-ts");
const monocle = require("monocle-ts");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const errorHandling_1 = require("../../utils/errorHandling");
const ActionTypes = require("../../actionTypes/distribution/wizard");
const Actions = require("../../actions/distribution/wizard");
const validation_1 = require("../../utils/validation");
const sok_types_1 = require("@caddigital/sok-types");
const getDelay = () => 5000;
exports.getDelay = getDelay;
const wizardLens = monocle.Lens.fromPath([
    'distribution',
    'wizard'
]);
const stepLens = (step) => new monocle.Optional((s) => s['step' + step] ? fp.option.some(s['step' + step]) : fp.option.none, 
/* istanbul ignore next */
(a) => (s) => s);
const activeStepLens = monocle.Lens.fromPath(['distribution', 'wizard', 'wizardStep']);
const recipientsLens = monocle.Lens.fromPath(['distribution', 'wizard', 'distributionRecipients']);
const validateStep = (step) => (store) => {
    const currentStep = activeStepLens.get(store);
    if (currentStep > step) {
        return fp.validation.success(true);
    }
    if (currentStep === 0) {
        return wizardLens
            .asOptional()
            .compose(stepLens(1))
            .getOption(store)
            .fold(fp.validation.failure([
            {
                key: 'any',
                value: 'Unhandled exception'
            }
        ]), (x) => {
            let v = fp.validation.success(true);
            v = (0, validation_1.ap)((0, validation_1.isNotEmpty)('name')(x))(v);
            v = (0, validation_1.ap)((0, validation_1.hasInvalidLength)('name', null, 101)(x.name))(v);
            v = (0, validation_1.ap)((0, validation_1.hasInvalidLength)('description', null, 101)(x.description))(v);
            return v;
        });
    }
    if (step === 2 || currentStep === 1) {
        const recipientsMap = recipientsLens.get(store);
        const recipients = Object.values(recipientsMap);
        if (recipients.length === 0 ||
            recipients.find((r) => r.deliveryMethod === -1)) {
            return fp.validation.failure([
                {
                    key: 'recipients',
                    value: 'no recipients, or missing deliverymethod'
                }
            ]);
        }
    }
    return fp.validation.success(true);
};
function changeStep(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.CHANGE_STEP), (0, operators_1.mergeMap)((request) => validateStep(request.payload.wizardStep)(store.value).fold((e) => (0, rxjs_1.of)(Actions.validateStepFailure(e)), (_) => (0, rxjs_1.of)(Actions.validateStepSuccess(request.payload.wizardStep)))));
}
exports.changeStep = changeStep;
function createNewDistribution(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.CREATE_NEW_DISTRIBUTION_REQUEST), (0, operators_1.mergeMap)((request) => {
        const step = store.value.distribution.wizard.wizardStep;
        return validateStep(step)(store.value).fold((e) => (0, rxjs_1.of)(Actions.validateStepFailure(e)), () => {
            return ajax({
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: getToken()
                },
                method: 'POST',
                body: request.payload,
                url: `${baseUrl}api/distribution`
            }).pipe((0, operators_1.mergeMap)(({ response }) => {
                const validation = sok_types_1.Distribution.iDistribution.decode(response);
                return validation.fold((err) => (0, rxjs_1.of)(Actions.editDistributionFailed((0, errorHandling_1.parseValidationError)(err))), (u) => (0, rxjs_1.of)(Actions.createNewDistributionSuccess(u)));
            }), (0, operators_1.catchError)((e) => (0, rxjs_1.of)(Actions.createNewDistributionFailed((0, errorHandling_1.parseAjaxErrorResponse)(e)))));
        });
    }));
}
exports.createNewDistribution = createNewDistribution;
function editDistribution(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.EDIT_DISTRIBUTION_REQUEST), (0, operators_1.mergeMap)((request) => {
        const step = store.value.distribution.wizard.wizardStep;
        return validateStep(step)(store.value).fold((e) => (0, rxjs_1.of)(Actions.validateStepFailure(e)), () => {
            return ajax({
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: getToken()
                },
                method: 'PUT',
                body: request.payload,
                url: `${baseUrl}api/distribution`
            }).pipe((0, operators_1.mergeMap)(({ response }) => {
                const validation = sok_types_1.Distribution.iDistribution.decode(response);
                return validation.fold((err) => (0, rxjs_1.of)(Actions.editDistributionFailed((0, errorHandling_1.parseValidationError)(err))), (u) => (0, rxjs_1.merge)((0, rxjs_1.of)(Actions.editDistributionSuccess(u)), (0, rxjs_1.of)(Actions.editDistributionStandby()).pipe((0, operators_1.delay)((0, exports.getDelay)()))));
            }), (0, operators_1.catchError)((e) => (0, rxjs_1.merge)((0, rxjs_1.of)(Actions.editDistributionFailed(e)), (0, rxjs_1.of)(Actions.editDistributionStandby()).pipe((0, operators_1.delay)((0, exports.getDelay)())))));
        });
    }));
}
exports.editDistribution = editDistribution;
//# sourceMappingURL=wizard.js.map